var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('h2',[_vm._v(" Team Details ")]),_c('GoogleMapLoader',{attrs:{"mapConfig":_vm.mapConfig,"apiKey":"YOUR_API_KEY"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }